import { defineComponent as B, ref as k, useSlots as v, computed as i } from "vue";
import l from "./td-longtail-vue-components86.js";
import { getConfig as s } from "./td-longtail-vue-components2.js";
const _ = /* @__PURE__ */ B({
  __name: "link-button",
  props: {
    tag: { default: "a" },
    tealiumName: { default: void 0 },
    tealiumSuffix: { default: void 0 },
    tealiumType: { default: "content" },
    disabled: { type: Boolean },
    primary: { type: Boolean },
    secondary: { type: Boolean },
    noStyling: { type: Boolean },
    transparent: { type: Boolean },
    transparentLight: { type: Boolean },
    transparentPrimary: { type: Boolean },
    outline: { type: Boolean },
    outlineLight: { type: Boolean },
    outlinePrimary: { type: Boolean },
    borderless: { type: Boolean },
    text: { type: Boolean },
    textNeutral: { type: Boolean },
    isWide: { type: Boolean },
    to: { default: void 0 },
    href: { default: void 0 },
    isExternal: { type: Boolean },
    sameWindow: { type: Boolean },
    smallPadding: { type: Boolean },
    large: { type: Boolean },
    medium: { type: Boolean },
    label: { default: void 0 },
    type: { default: void 0 },
    iconOnly: { type: Boolean },
    checked: { type: Boolean }
  },
  emits: ["click"],
  setup(h, { expose: b, emit: y }) {
    const t = h, p = k(null), o = v(), m = i(() => {
      const e = [];
      return e.push("link-button btn"), t.isWide && e.push("btn--is-wide"), t.primary && e.push("btn--primary"), t.secondary && e.push("btn--secondary"), t.noStyling && e.push("btn--no-style"), t.outline && e.push("btn--outline"), t.outlineLight && e.push("btn--outline-light"), t.outlinePrimary && e.push("btn--outline-primary"), t.transparent && e.push("btn--transparent"), t.transparentLight && e.push("btn--transparent-light"), t.transparentPrimary && e.push("btn--transparent-primary"), t.text && e.push("btn--text"), t.textNeutral && e.push("btn--text btn--text-neutral"), t.disabled && e.push("btn--disabled"), t.smallPadding && e.push("btn--small-padding"), t.isExternal && e.push("link--external"), t.large && e.push("btn--large"), t.medium && e.push("btn--medium"), t.iconOnly && e.push("btn--icon-only"), t.checked && e.push("btn--checked"), !t.primary && !t.secondary && !t.outline && !t.outlineLight && !t.outlinePrimary && !t.transparent && !t.transparentLight && !t.transparentPrimary && !t.text && !t.textNeutral && !t.noStyling && e.push("btn--default"), e;
    }), r = i(() => t.text ? "text" : "button"), f = (e, a = 0) => {
      if (!(!e || !Array.isArray(e)))
        return e.map((n) => {
          if (n?.text) return n.text;
          if (a <= 2 && n.children)
            return f(n.children, a + 1);
        }).filter(Boolean).join("");
    }, u = i(() => {
      let e;
      if (t.tealiumName) e = l(t.tealiumName);
      else if (t.label) e = l(t.label);
      else if (p.value?.textContent) e = l(p.value.textContent);
      else if (o.default && typeof o.default == "function") {
        const a = o.default();
        if (a) {
          const n = f(a);
          e = n ? l(n) : void 0;
        }
      }
      return e ? t.tealiumSuffix ? `${t.tealiumType}.${r.value}.${e}.${l(
        t.tealiumSuffix
      )}` : `${t.tealiumType}.${r.value}.${e}` : null;
    }), c = i(() => t.tag === "nuxt-link" && s()?.nuxtLink ? s().nuxtLink : t.tag), d = i(() => t.to || t.href), x = i(() => c.value === "nuxt-link" ? {
      to: d.value
    } : {
      href: d.value
    }), g = (e) => {
      s()?.tealium?.link && u.value && s().tealium?.link({ wt_link_id: u.value }), y("click", e);
    };
    return b({ classes: m, linkType: r, dataTealium: u }), { __sfc: !0, props: t, linkElement: p, emit: y, slots: o, classes: m, linkType: r, getTextFromVNode: f, dataTealium: u, tagComponent: c, link: d, linkProps: x, onClick: g };
  }
});
export {
  _ as default
};
